const settings = {
    // baseUrlApi: "http://localhost:60385/api",
    baseUrlApi: "https://firelog-api.ipcom.be/api",
    // iHubBaseUrlApi: "http://localhost:64406/api",
    iHubBaseUrlApi: "https://ihub-api.ipcom.be/api",
    // oryxUrlApi: "http://localhost:13279/",
    oryxUrlApi: "https://pim.oryx.ipcomdigital.eu/api",
    oryxUrlBaseUrl: "https://pim.oryx.ipcomdigital.eu/",
    // oryxUrlBaseUrl: "http://localhost:13279/",


    // admin: 10,
    // readonly: 11,
    // installer: 17,    

    admin: 7,
    readonly: 8,
    installer: 14,
    noaccess: 15,

    firelogapplicationId: 2
};

export default settings;


// WEBPACK FOOTER //
// ./src/settings/settings.js